import { Column } from '../../components/table/types';
import AccountState from '../../components/account-state';
import TableStatus from '../../components/table-status';
import { UserManagementProps, roleLabel } from '../user-management/api/types';
import { FilterConfig, Filters } from '../../types';
import EllipsisText from '../../components/text-ellipsis';
import { commonDataTableFilterConfig, EMPTY_FIELD } from '../../constants';
import { Product } from '../products/api/types';
import { i18n } from '@senderra/translations';

export const DEFAULT_FILTERS: UserManagementProps & Filters = {
    name: '',
    status: 'none',
    state: 'none',
    drugShortNames: [],
    pageNumber: 0,
    pageSize: 10,
    sorted: null,
};

export const columns: Column[] = [
    {
        id: 'firstName',
        title: i18n.t('first-name'),
        width: 150,
        isSorted: true,
    },
    {
        id: 'lastName',
        title: i18n.t('last-name'),
        width: 150,
    },
    {
        id: 'roleName',
        title: i18n.t('role'),
        isSorted: true,
        component: (props) => <EllipsisText text={roleLabel[props.roleName] || EMPTY_FIELD} />,
    },
    {
        id: 'title',
        title: i18n.t('title'),
    },
    {
        id: 'email',
        title: i18n.t('email'),
    },
    {
        id: 'phoneNumber',
        title: i18n.t('phone-number'),
    },
    {
        id: 'products',
        title: i18n.t('products'),
        component: (props) => {
            const combinedShortNames =
                props.products.length > 0 ? props.products.map((product: Product) => product.shortName).join(', ') : EMPTY_FIELD;
            return <EllipsisText text={combinedShortNames} />;
        },
    },
    {
        id: 'status',
        title: i18n.t('status'),
        component: (props) => <TableStatus status={props.text} statuses={['Active', 'Pending']} />,
    },
    {
        id: 'isLocked',
        title: i18n.t('account-state'),
        component: AccountState,
    },
];

export const filterConfig: FilterConfig = { ...commonDataTableFilterConfig };
